<script setup lang="ts">
import { useSessionMembership, useSignedIn } from '@/composables/session/useSession'
import { LANDING_HERO } from '@/content/landing'

const isHydrated = ref(false)

onNuxtReady(() => {
  isHydrated.value = true
})

// Only a visitor the header shows as signed in, and who has a membership record, has a
// membership to view. The session domain reads both without loading the wallet stack for
// a visitor who has no session.
const { isSignedIn } = useSignedIn()
const { membershipQuery } = useSessionMembership()

const cta = computed(() =>
  isHydrated.value && isSignedIn.value && membershipQuery.data.value != null
    ? LANDING_HERO.cta.member
    : LANDING_HERO.cta.join,
)
</script>

<template>
  <div>
    <h1 class="font-heading text-[2.4rem] leading-[1.05] font-bold tracking-tight text-balance sm:text-[3.4rem]">
      <span class="block text-ink">{{ LANDING_HERO.heading.lead }}</span>
      <span class="hero-accent mt-1 block">{{ LANDING_HERO.heading.accent }}</span>
    </h1>

    <p class="mt-6 max-w-md text-lg/relaxed text-subtitle">
      {{ LANDING_HERO.subheading }}
    </p>

    <div class="mt-8 flex flex-wrap items-center gap-x-5 gap-y-3">
      <UIButton variant="cta" size="lg" :to="cta.href" :prefetch="false">
        {{ cta.label }}
      </UIButton>
      <NuxtLink :to="LANDING_HERO.freeLink.href" class="tier-free-link">
        {{ LANDING_HERO.freeLink.label }}
        <span aria-hidden="true">→</span>
      </NuxtLink>
    </div>
  </div>
</template>
